import { Box, Checkbox, CheckboxProps, Typography } from '@mui/material'
import Stack from '@mui/material/Stack'
import * as sxStyles from './ColoredList.styled'

export enum SHAPES {
  SQUARE = 'square',
  CIRCLE = 'circle',
}

export type TColotesListValues = {
  id: number
  name: string
  color: string
}

export type TColorItem = TColotesListValues & {
  checked?: boolean
}

interface IColoredList {
  valuesList: TColorItem[]
  shape: SHAPES
  title: string
  withCheckbox?: boolean
  onToggle?: (id: number, checked: boolean) => void
  checkboxProps?: CheckboxProps
  maxHeight?: string
}

const ColoredList = ({
  valuesList,
  shape,
  title,
  withCheckbox = false,
  onToggle,
  checkboxProps,
  maxHeight = '43vh',
}: IColoredList) => {
  const borderRadius = shape === SHAPES.CIRCLE ? '50%' : 0
  return (
    <Stack spacing={1}>
      {title && (
        <Typography variant="subtitle1" sx={sxStyles.typographyStyle}>
          {title}
        </Typography>
      )}

      <Stack
        component="ul"
        sx={{
          ...sxStyles.stackWrapperStyle,
          maxHeight,
        }}
      >
        {valuesList.map((value: TColorItem) => (
          <Stack
            key={value.id}
            component="li"
            direction="row"
            alignItems="center"
            spacing={1}
          >
            {withCheckbox && (
              <Checkbox
                sx={sxStyles.checkBoxStyle}
                size="small"
                checked={Boolean(value.checked)}
                onChange={(e) => onToggle?.(value.id, e.target.checked)}
                {...checkboxProps}
              />
            )}

            <Box
              aria-hidden
              sx={{
                ...sxStyles.boxTitleWrapper,
                borderRadius: borderRadius,
                bgcolor: value.color,
              }}
            />
            <Typography variant="subtitle1">{value.name}</Typography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  )
}

export default ColoredList
